export default {
  entity: {
    history: 'History',
    type: {
      UPDATE: 'Update',
      INITIAL: 'Initial',
    },
  },
}
